import React, { createContext, useContext, useEffect, useState } from 'react';
import CasinoVideo from "../component/media/CasinoVideo";
import HeaderNavBar from "../component/common/header_nav_bar";
import Container from "../component/layout/Container";
import MainGameNewListLayout from "../component/list/main_game_list_layout";
// import main_logo from "../_asset/media/main_banner title.png"
import main_logo from "../_asset/bg/Angel_Casino_Logo1.png"
import Footer from "../component/common/footer";

import 'bootstrap/dist/css/bootstrap.min.css';
import "../_asset/css/v2.css.css"
import CookieSetComponent from "../component/common/CookieSetComponent";
import { LoginModal } from "../component/pop_pages/user/login_popup";
import { RegisterModal } from "../component/pop_pages/user/register_popup";
import { OdometerTags } from "../component/layout/odometer";
import useInterval from "../hooks/useInterval";

import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import { Autoplay } from "swiper";
import moment from "moment";
import { with_comma } from "../util/comma";
import api from "../util/api";

import GameLoading from '../component/provider/game_loading_provider';
import LobbyModalProvider from "../component/provider/lobby_modal_provider";
import { UserContext } from "./_root";
import { PrivateUser } from "../hooks/useUser";
import ReplayModalIframe from "../component/layout/replay_modal_iframe";
import { Player } from "@lottiefiles/react-lottie-player";

import loading from "../_asset/lottie/loading_2.json"
import licenseBanner from "../_asset/banner/License_banner_1.png"
import licenseBanner_pragmatic from "../_asset/banner/banner_pragmatic.png"
import licenseBanner_evolution from "../_asset/banner/banner_evolution.png"
import { Logo_2 } from '../component/common/logo';
import LicenseBannerPopup from '../component/banner/license';
import EventAdLayout from '../component/banner/event_ad';
import MainIntro from '../component/common/banner';
import MainBanner from '../component/common/banner';
import TitleHeader from '../component/layout/title_header';
import LicenseBannerPopupEvolution from '../component/banner/license_evolution';
import won from './../_asset/etc/won.svg'
import license_pra from './../_asset/banner/license_pra.png'
import license_evo from './../_asset/banner/license_evo.png'
import { noticeApiInterface, noticeListInterface, NoticeModal } from '../component/pop_pages/board/notice_popup';


interface ACTION_INTERFACE {
    SetLoginPop: () => void
    SetRegisterPop: () => void
}

export const actionContext = createContext<ACTION_INTERFACE>({
    SetLoginPop: () => { },
    SetRegisterPop: () => { },
})

export default function Home() {
    const [loginShow, setLoginShow] = useState(false)
    const [registerShow, setRegisterShow] = useState<boolean>(false)

    const [reloadState, setReloadState] = useState<boolean>(false)

    document.onkeydown = function (e) {
        /* F5, Ctrl+r, Ctrl+F5 */
        if (e.keyCode == 116 || e.ctrlKey == true && (e.keyCode == 82)) {
            setReloadState(true)
            e.cancelBubble = true;
            e.returnValue = false;
            setTimeout(function () {
                window.location.reload();
            }, 1000);
            return false;
        }
    }

    function SetLoginPop() {
        setLoginShow(true)
    }
    function SetRegisterPop() {
        setRegisterShow(true)
    }

    return (
        <actionContext.Provider value={{ SetLoginPop, SetRegisterPop }}>
            <GameLoading>
                <LobbyModalProvider>
                    <CasinoVideo />
                    <CookieSetComponent />
                    <div id={"body-container"}>
                        <HeaderNavBar /> {/* fixed */}
                        <main>           {/* container */}
                            <div className='main-flex'>
                                {/* <EventAdLayout>
                                </EventAdLayout> */}
                                <Container>
                                    <div className="body-wrap">
                                        <MainBanner />
                                        <div className='mo-reverse'>
                                            <div className={'list-layouts'} >
                                                {/* <JackpotLayout /> */}
                                                {/* <LicenseLayout /> */}
                                                <RandingNoticeList />
                                                <RealTimeDepositList />
                                                <RealtimeJackPotList />
                                            </div>
                                            <LicenseOdometerLayout />
                                        </div>
                                        <MainGameNewListLayout />
                                    </div>
                                </Container>
                            </div>
                            <Footer />
                        </main>
                    </div>
                </LobbyModalProvider>
            </GameLoading>
            <LoginModal loginPopShow={loginShow} setLoginPopShow={setLoginShow} />
            <RegisterModal registerPopShow={registerShow} setRegisterPopShow={setRegisterShow} title={"회원가입"} />
        </actionContext.Provider>
    );
}

function LicenseOdometerLayout() {
    const { User } = useContext(UserContext)
    const { SetLoginPop } = useContext(actionContext)
    const [popShow, setPopShow] = useState<boolean>(false)
    const [popShowEvolution, setPopShowEvolution] = useState<boolean>(false)
    return (
        <>
            <div className='license-odometer'>
                <div>
                    <img src={license_pra} alt="" className='--pointer' onClick={e => {
                        if (User.is_authenticated) {
                            setPopShow(true)
                        } else {
                            SetLoginPop()
                        }
                    }} />
                </div>
                <JackpotLayout />
                <div>
                    <img src={license_evo} alt="" className='--pointer' onClick={e => {
                        if (User.is_authenticated) {
                            setPopShowEvolution(true)
                        } else {
                            SetLoginPop()
                        }
                    }} />
                </div>
            </div>
            <LicenseBannerPopup popShow={popShow} setPopShow={setPopShow} />
            <LicenseBannerPopupEvolution popShow={popShowEvolution} setPopShow={setPopShowEvolution} />
        </>
    )
}

function JackpotLayout() {
    const [odometerNumber, setOdometerNumber] = useState<number>(0)

    useEffect(() => {
        let setOdometerDefaultNumber = Math.floor(Math.random() * 10000000000)
        while (setOdometerDefaultNumber < 1000000000) {
            setOdometerDefaultNumber = Math.floor(Math.random() * 10000000000)
        }
        setOdometerNumber(setOdometerDefaultNumber)
    }, [])
    useInterval(() => {
        let random_count = Math.floor(Math.random() * 10000)
        setOdometerNumber(odometerNumber + random_count)
    }, 900)
    return (
        <div className={'jackpot-layout'}>
            <OdometerTags odometerNumber={odometerNumber} />
        </div>
    )
}

interface RealTimeDepositListInterface {
    "kind": string,
    "amount": number,
    "user": string,
    "processed_at": string
}
function RandingNoticeList() {
    const [noticeList, setNoticeList] = useState<noticeListInterface[]>()
    const [show, setShow] = useState<boolean>(false)
    const [openReadId, setOpenReadId] = useState<number>()
    const [noticeDetail, setNoticeDetail] = useState<noticeListInterface>({
        id: 0,
        title: "",
        content: "",
        written_at: "",
    })

    function updateList() {
        api(`/api/site/notices/?page=1`)
            .then(res => res.json())
            .then((data: noticeApiInterface) => {
                setNoticeList(data.notices)
            })
    }
    useEffect(() => {
        updateList()
    }, [])

    useEffect(() => {
        if (openReadId) {
            setShow(true)
        }
    }, [openReadId])
    return (
        <div className={'list-layout realtime-deposit-layout'}>
            <TitleHeader type='request_deposit'>
                <p>공지사항</p>
                {/* <span>live deposit</span> */}
            </TitleHeader>
            {
                noticeList
                    ? <Swiper
                        direction={'vertical'}
                        // spaceBetween={4}
                        // autoplay={{
                        //     delay: 1500
                        // }}
                        freeMode={true}
                        loop={true}
                        slidesPerView={4}
                        className={'list-main realtime-deposit-list'}
                        modules={[Autoplay]}
                    >
                        {
                            noticeList.map((list, index) => {
                                const oddEven = index % 2 ? `odd` : `even`
                                return (
                                    <SwiperSlide key={index} className={`list-item ${oddEven}`}>
                                        <RandingNoticeItem list={list} setOpenReadId={setOpenReadId} setNoticeDetail={setNoticeDetail} />
                                    </SwiperSlide>
                                )
                            })
                        }
                        {
                            noticeList.length > 5 && noticeList.length < 9
                                ? noticeList.map((list, index) => {
                                    const oddEven = index % 2 ? `odd` : `even`
                                    return (
                                        <SwiperSlide key={index} className={`list-item ${oddEven}`}>
                                            <RandingNoticeItem list={list} setOpenReadId={setOpenReadId} setNoticeDetail={setNoticeDetail} />
                                        </SwiperSlide>
                                    )
                                })
                                : <></>
                        }
                    </Swiper>
                    : <div className={'list-main realtime-deposit-list'}>
                        <Player src={loading}
                            autoplay
                            loop
                            style={{ width: "50%", height: "50%" }}
                        ></Player>
                    </div>
            }
            <NoticeModal registerPopShow={show} setRegisterPopShow={setShow} openReadId={openReadId} />
        </div>
    )
}
function RandingNoticeItem({ list, setOpenReadId, setNoticeDetail }:
    { list: noticeListInterface, setOpenReadId: Function, setNoticeDetail: Function }) {
    const { User } = useContext(UserContext)
    const { SetLoginPop } = useContext(actionContext)

    return (
        <div className={`realtime-notice-items --pointer`} onClick={e => {
            if (User?.is_authenticated) {
                setOpenReadId(list.id)
                setNoticeDetail(list)
            } else {
                SetLoginPop()
            }
        }} >
            <div>{list.title}</div>
            <div>{moment(Date()).format('MM-DD')}</div>
        </div>
    )
}

function RealTimeDepositList() {
    const [depositList, setDepositList] = useState<RealTimeDepositListInterface[]>()
    // const depositCostTemplate = [10000, 50000, 100000, 500000]

    function updateList() {
        api(`/api/wallet/live_depositwithdrawals/`)
            .then(res => res.json())
            .then((data: RealTimeDepositListInterface[]) => {
                setDepositList(data)
            })
    }
    useEffect(() => {
        updateList()
    }, [])
    // useInterval(() => {
    //     updateList()
    // }, 60000)
    return (
        <div className={'list-layout realtime-deposit-layout'}>
            <TitleHeader type='request_deposit'>
                <p>실시간 입출금 현황</p>
                {/* <span>live deposit</span> */}
            </TitleHeader>
            {
                depositList
                    ? <Swiper
                        direction={'vertical'}
                        // spaceBetween={4}
                        // autoplay={{
                        //     delay: 1500
                        // }}
                        freeMode={true}
                        loop={true}
                        slidesPerView={4}
                        className={'list-main realtime-deposit-list'}
                        modules={[Autoplay]}
                    >
                        {
                            depositList.map((list, index) => {
                                const oddEven = index % 2 ? `odd` : `even`
                                return (
                                    <SwiperSlide key={index} className={`list-item ${oddEven}`}>
                                        <RealTimeDepositItem list={list} />
                                    </SwiperSlide>
                                )
                            })
                        }
                        {
                            depositList.length > 5 && depositList.length < 9
                                ? depositList.map((list, index) => {
                                    const oddEven = index % 2 ? `odd` : `even`
                                    return (
                                        <SwiperSlide key={index} className={`list-item ${oddEven}`}>
                                            <RealTimeDepositItem list={list} />
                                        </SwiperSlide>
                                    )
                                })
                                : <></>
                        }
                    </Swiper>
                    : <div className={'list-main realtime-deposit-list'}>
                        <Player src={loading}
                            autoplay
                            loop
                            style={{ width: "50%", height: "50%" }}
                        ></Player>
                    </div>
            }
        </div>
    )
}

function RealTimeDepositItem({ list }: { list: RealTimeDepositListInterface; }) {
    return (
        <div className={`realtime-deposit-items`}>
            <div>{list.kind}</div>
            <div>{list.user}</div>
            <div>{with_comma(list.amount)}</div>
            <div>{moment(list.processed_at).format('YYYY-MM-DD')}</div>
        </div>
    )
}


interface RealtimeJackpotInterface {
    "username": string,
    "nickname": string,
    "game_title": string,
    "win": number,
    "odds": number,
    "link": string
}
function RealtimeJackPotList() {
    const { User } = useContext(UserContext)
    const { SetLoginPop } = useContext(actionContext)

    const [jackpotList, setJackpotList] = useState<RealtimeJackpotInterface[]>()
    const [replayShow, SetReplayShow] = useState<boolean>(false)
    const [replayLink, setReplayLink] = useState<string>("")
    // const depositCostTemplate = [10000, 50000, 100000, 500000]

    function updateList() {
        api(`/api/game/jackpots/`)
            .then(res => res.json())
            .then((data: RealtimeJackpotInterface[]) => {
                setJackpotList(data)
            })
    }
    useEffect(() => {
        updateList()
    }, [])
    // useInterval(() => {
    //     updateList()
    // }, 60000)

    return (
        <div className={'list-layout realtime-deposit-layout'}>
            <TitleHeader type='event'>
                <p>금주의 잭팟 TOP</p>
                {/* <span>weekend jackpot</span> */}
            </TitleHeader>
            {
                jackpotList
                    ? <Swiper
                        direction={'vertical'}
                        // spaceBetween={4}
                        // autoplay={{
                        //     delay: 1500,
                        //     pauseOnMouseEnter: true
                        // }}
                        freeMode={true}
                        loop={jackpotList.length > 5 ? true : false}
                        slidesPerView={4}
                        className={'list-main realtime-deposit-list'}
                        modules={[Autoplay]}
                    >
                        {
                            jackpotList.map((list, index) => {
                                const oddEven = index % 2 ? `odd` : `even`
                                return (
                                    <SwiperSlide key={index} className={`list-item ${oddEven}`}>
                                        <RealTimeJackpotItem list={list}
                                            User={User}
                                            SetLoginPop={SetLoginPop}
                                            SetReplayShow={SetReplayShow}
                                            setReplayLink={setReplayLink} />
                                    </SwiperSlide>
                                )
                            })
                        }
                        {
                            jackpotList.length > 5 && jackpotList.length < 10
                                ? jackpotList.map((list, index) => {
                                    const oddEven = index % 2 ? `odd` : `even`
                                    return (
                                        <SwiperSlide key={index} className={`list-item ${oddEven}`}>
                                            <RealTimeJackpotItem list={list}
                                                User={User}
                                                SetLoginPop={SetLoginPop}
                                                SetReplayShow={SetReplayShow}
                                                setReplayLink={setReplayLink} />
                                        </SwiperSlide>
                                    )
                                })
                                : <></>
                        }
                    </Swiper>
                    : <div className={'list-main realtime-deposit-list'}>
                        <Player src={loading}
                            autoplay
                            loop
                            style={{ width: "50%", height: "50%" }}
                        ></Player>
                    </div>
            }
            <ReplayModalIframe link={replayLink}
                replayShow={replayShow}
                SetReplayShow={SetReplayShow} />
        </div>
    )
}

function RealTimeJackpotItem({ list, User, SetLoginPop, SetReplayShow, setReplayLink }:
    {
        list: RealtimeJackpotInterface;
        User: PrivateUser;
        SetLoginPop: Function;
        SetReplayShow: Function;
        setReplayLink: Function;
    }) {

    function openReplay(link: string) {
        if (User?.is_authenticated) {
            SetReplayShow(true)
            setReplayLink(link)
        } else {
            SetLoginPop()
        }
    }
    return (
        <div className={`realtime-jackpot-items`}>
            <div>{list.username}</div>
            <div>{list.game_title}</div>
            <div>{with_comma(list.win)}</div>
            <div>
                X{with_comma(list.odds)}배
                <span onClick={e => openReplay(list.link)}>R</span>
            </div>
        </div>
    )
}
